import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import Fade from "react-reveal/Fade";
import axios from "axios";

const ExtraInfoComponent = () => {
  const [projects, setProjects] = useState([]);
  const [happyClients, setHappyClients] = useState(0);
  const [projectsDone, setProjectsDone] = useState(0);
  const [experience, setExperience] = useState(0);
  const yearsOfExperience = new Date().getFullYear() - 2021;
  const [ref, inView] = useInView({ threshold: 0.5 });

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const { data } = await axios.get(process.env.REACT_APP_PROJECTS_URL);
        setProjects(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Failed to load projects:", err);
      }
    };
    fetchProjects();
  }, []);

  useEffect(() => {
    if (inView && happyClients < (projects.length - 1)) {
      const interval = setInterval(() => setHappyClients((prev) => prev + 1), 100);
      return () => clearInterval(interval);
    }
  }, [inView, happyClients, projects.length]);

  useEffect(() => {
    if (inView && projectsDone < projects.length) {
      const interval = setInterval(() => setProjectsDone((prev) => prev + 1), 100);
      return () => clearInterval(interval);
    }
  }, [inView, projectsDone, projects.length]);

  useEffect(() => {
    if (inView && experience < yearsOfExperience) {
      const interval = setInterval(() => setExperience((prev) => prev + 1), 100);
      return () => clearInterval(interval);
    }
  }, [inView, experience, yearsOfExperience]);

  return (
    <div ref={ref} className="h-full w-full bg-primary px-[30px] pt-[70px] pb-[130px]">
      <div className="extra-con">
        <div className="rounded-tl-[25px] rounded-tr-[25px] md:rounded-tr-none md:rounded-tl-[25px] md:rounded-bl-[25px] lg:rounded-tl-[45px] lg:rounded-bl-[45px] z-10">
          <Fade bottom>
            <h1>{happyClients}</h1>
            <p>Happy Clients</p>
          </Fade>
        </div>
        <div>
          <Fade bottom delay={200}>
            <h1>{projectsDone}</h1>
            <p>Projects Done</p>
          </Fade>
        </div>
        <div>
          <Fade bottom delay={400}>
            <h1>0</h1>
            <p>Award Winning</p>
          </Fade>
        </div>
        <div className="rounded-bl-[25px] rounded-br-[25px] md:rounded-bl-none md:rounded-tr-[25px] md:rounded-br-[25px] lg:rounded-tr-[45px] lg:rounded-br-[45px] z-10">
          <Fade bottom delay={600}>
            <h1>{experience}</h1>
            <p>Years Experience</p>
          </Fade>
        </div>
        <Fade right>
          <div className="absolute h-[130px] w-[130px] rounded-[50%] border-[25px] border-secondary right-[25px] top-[-50px]"></div>
        </Fade>
        <Fade left>
          <div className="absolute h-[120px] w-[120px] rounded-[50%] bg-gradient-to-b from-secondary to-text bottom-[-50px] left-[-40px]"></div>
        </Fade>
      </div>
    </div>
  );
};

export default ExtraInfoComponent;